module.exports = __webpack_public_path__ + "img/mag-all.32089e2b.png";